import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../assets/svg/move.svg';
import moreIcon from '../assets/svg/more.svg';
import holidayIcon from '../assets/svg/holiday.svg';

//const ReactGridLayout = WidthProvider(RGL);
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";

const LightTooltipHoliday = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#e61f00",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

function checkEventOverlap(event, eventList) {
    let overlappingEvents = [];

    const { startTime: eventStart, endTime: eventEnd } = event;

    for (let currentEvent of eventList) {
        const { startTime: currentStart, endTime: currentEnd } = currentEvent;

        if (
            (eventStart < currentEnd && eventEnd > currentStart) ||
            (eventStart <= currentStart && eventEnd >= currentEnd) // && (eventEnd >= currentEnd || (eventEnd < currentEnd && eventEnd > currentStart))
        ) {
            overlappingEvents.push(currentEvent);
        }
    }

    return overlappingEvents.length > 0 ? overlappingEvents : null;
}

function hexToRgba(hex, alpha = 1) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    const bigint = parseInt(hex, 16);
    const red = (bigint >> 16) & 255;
    const green = (bigint >> 8) & 255;
    const blue = bigint & 255;

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}


function getColorOfEvent(type, onlineVisit, event) {
    let obj = {}

    if (type == 'referral') {
        if (onlineVisit) {
            obj = {
                backgroundColor: 'rgb(58, 63, 86)',
                color: '#ffff'
            }
        } else {
            obj = {
                backgroundColor: '#568ac8',
                color: '#ffff'
            }
        }

    } else if (type == 'revisit') {
        if (onlineVisit) {
            obj = {
                backgroundColor: 'rgb(58, 63, 86)',
                color: '#ffff'
            }
        } else {
            obj = {
                backgroundColor: '#60bebb',
                color: '#ffff'
            }
        }

    } else if (type == 'event') {
        obj = {
            backgroundColor: '#dbd233',
            color: '#ffff'
        }
    } else if (type == 'free') {
        let bg = event && !event.allActiveForms && (!event.eventForms || (event.eventForms && Array.isArray(event.eventForms) && !event.eventForms.length)) ? 'rgba(86, 200, 138, 0.5)' : '#008000'
        obj = {
            backgroundColor: bg,
            color: '#ffff'
        }
    } else if (type == 'template') {
        obj = {
            backgroundColor: '#E0BEEC',
            border: '2px dotted #fff',
            color: '#ffff'
        };
        if (event?.templateData?.calendarColor) {
            obj.backgroundColor = hexToRgba(event.templateData.calendarColor, 0.7);
        }
    }




    return obj;
}


/**
* AppBuilder
* @author   Milan Stanojevic
*/
class DragAndDropList extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        this.state = {
            clipboard: []
        }
    }

    onLayoutChange = (layout) => {

        let oldLayout = [];
        let changedItems = [];

        for (let i = 0; i < this.props.cols.length; i++) {
            for (let j = 0; j < this.props.cols[i].events.length; j++) {
                // let startDate = new Date(this.props.cols[i].events[j].startTime * 1000);
                // let startDate = new Date(this.props.getStringDateTs(this.props.cols[i].events[j].startTime, this.props.dateFormat))
                let startDate = new Date(this.props.getStringDateTs(this.props.cols[i].events[j].startTime, 'MM/DD/YYYY HH:mm'))
                startDate.setHours(0);
                startDate.setMinutes(0);
                startDate.setSeconds(0);
                startDate.setMilliseconds(0);
                let startTimestamp = Math.floor(startDate.getTime() / 1000);

                for (let k = 0; k < layout.length; k++) {
                    if (layout[k].i == this.props.cols[i].events[j]._id) {
                        let generatedItem = {
                            i: this.props.cols[i].events[j]._id,
                            x: i,
                            w: 1,
                            maxW: 1,
                            y: Math.ceil(((Math.floor(new Date(this.props.getStringDateTs(this.props.cols[i].events[j].startTime, 'MM/DD/YYYY HH:mm')).getTime() / 1000) - startTimestamp)) / (5 * 60)),
                            h: Math.ceil((((this.props.cols[i].events[j].endTime - this.props.cols[i].events[j].startTime) / (5 * 60))))
                        }

                        if (layout[k].x != generatedItem.x || layout[k].y != generatedItem.y || layout[k].h != generatedItem.h) {
                            this.props.onChange({
                                _id: layout[k].i,
                                column: this.props.cols[layout[k].x]._id,
                                startTime: startTimestamp + layout[k].y * (5 * 60),
                                endTime: startTimestamp + layout[k].y * (5 * 60) + layout[k].h * (5 * 60),
                                columnChanged: layout[k].x != generatedItem.x,
                                oldColumn: generatedItem.x
                            })
                            return;
                        }

                    }
                }

            }
        }

        //this.props.onChange(changedItems);

    }

    onDrop = (layout, layoutItem, _event) => {
        // if (layoutItem._id)
        this.props.addFromClipboard(this.state.dragElementType, layoutItem, () => this.setState({ dragElementType: null }))




    };

    componentDidMount() {
        if (this.props.clipboard) {
            this.setState({ clipboard: this.props.clipboard })
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.clipboard != this.props.clipboard) {
            this.setState({ clipboard: this.props.clipboard })
        }

    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = (event) => {

        if (this.wrapperRef && this.wrapperRef.contains && !this.wrapperRef.contains(event.target)) {
            this.setState({ contextMenu: null })
        }
    }
    setOverlapDataToEvent = (item, overlap) => {
        let items = [{ ...item }, ...overlap];

        let overlapData = {
            // position: newArr.findIndex(el => el._id == item._id),
            overlap: overlap?.map(el => el._id),
            total: items.length
        }

        return overlapData;
    }
    checkPosition = (items) => {
        for (let i = 0; i < items.length; i++) {
            if (!items[i].overlapData || (items[i].overlapData?.sorted)) {
                continue;
            }
            let overlap = items[i].overlapData.overlap;
            let position = 0;
            for (let j = 0; j < overlap.length; j++) {
                let element = items.find(el => el._id == overlap[j]);
                if (element?.overlapData?.sorted) {
                    position++;
                }
            }
            items[i].overlapData.position = position;
            items[i].overlapData.sorted = true;

        }


        return items;
    }
    checkOverlap = (items) => {
        for (let i = 0; i < items.length; i++) {
            delete items[i].overlapData;
            let item = items[i];
            let overlap = checkEventOverlap(item, items.filter(el => el._id != item._id && el.doctor === item.doctor));
            if (overlap?.length) {
                items[i].overlapData = this.setOverlapDataToEvent({ ...item }, [...overlap])
            }
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].overlapData?.overlap?.length) {
                let overlap = items[i].overlapData.overlap;
                for (let j = 0; j < items[i].overlapData.overlap.length; j++) {
                    let element = items.find(el => el._id == items[i].overlapData.overlap[j]);
                    if (element?.overlapData?.overlap?.length) {
                        for (let e = 0; e < element.overlapData.overlap.length; e++) {
                            if (!items[i].overlapData.overlap.includes(element.overlapData.overlap[e])) {
                                overlap.push(element.overlapData.overlap[e])
                            }
                        }
                    }
                }
                items[i].overlapData.overlap = overlap;
                items[i].overlapData.total = items[i].overlapData.overlap.length;
            }
        }
        return this.checkPosition(items?.sort((a, b) => a.startTime - b.startTime));
    }

    setWidthOfElement = (className, width, counter = 0) => {
        if (typeof window == 'undefined') return;

        if (counter > 10) return;
        let element = document.getElementsByClassName(className);
        if (element?.length) {
            element[0].style.width = `${width}px`;
        } else {
            setTimeout(() => {
                this.setWidthOfElement(className, width, counter + 1)
            }, 100);
        }

    }

    render() {
        const STEP_HEIGHT = 10;
        const STEP = 5 * 60;
        const SECOND_HEIGHT = STEP_HEIGHT / STEP;

        let layout = [];
        let items = [];
        for (let i = 0; i < this.props.cols.length; i++) {
            for (let j = 0; j < this.props.cols[i].events.length; j++) {
                if (!this.props.cols[i].events[j].deleted && !this.props.cols[i].events[j].forDelete) {
                    items.push(this.props.cols[i].events[j]);


                    // let startDate = new Date(this.props.cols[i].events[j].startTime * 1000);
                    // let startDate = new Date(this.props.getStringDateTs(this.props.cols[i].events[j].startTime, this.props.dateFormat))
                    let startDate = new Date(this.props.getStringDateTs(this.props.cols[i].events[j].startTime, 'MM/DD/YYYY HH:mm'))
                    startDate.setHours(0);
                    startDate.setMinutes(0);
                    startDate.setSeconds(0);
                    startDate.setMilliseconds(0);
                    let startTimestamp = Math.floor(startDate.getTime() / 1000);

                    layout.push({
                        i: this.props.cols[i].events[j]._id,
                        x: i,
                        w: 1,
                        maxW: 1,
                        y: Math.ceil(((Math.floor(new Date(this.props.getStringDateTs(this.props.cols[i].events[j].startTime, 'MM/DD/YYYY HH:mm')).getTime() / 1000) - startTimestamp)) / (5 * 60)),
                        h: Math.ceil((((this.props.cols[i].events[j].endTime - this.props.cols[i].events[j].startTime) / (5 * 60)))),
                        static: (this.props.cols[i].events[j].startTime < Math.floor(new Date().getTime() / 1000)) || (this.props.cols[i].events[j].eventId || this.props.cols[i].events[j].eventFromAnotherClinic || this.props.cols?.[i]?.events?.[j]?.takeCare || this.props.cols?.[i]?.events?.[j]?.semble || this.props.cols[i].events[j].inClipboard || this.props.cols[i].events[j].reserved) ? true : false
                    })
                }

            }
        }
        items.sort((a, b) => b.startTime - a.startTime)

        items = this.checkOverlap(items);

        let newDate = new Date(this.props.date.getFullYear(), this.props.date.getMonth(), this.props.date.getDate(), this.props.min ? this.props.min.hours : 0, this.props.min ? this.props.min.minutes : 0, 0, 0);
        let endDate = new Date(this.props.date.getFullYear(), this.props.date.getMonth(), this.props.date.getDate(), this.props.max ? this.props.max.hours : 23, this.props.max ? this.props.max.minutes : 59, 59, 999);
        // let newDate = new Date(this.props.getStringDateTs(Math.floor(new Date(this.props.date.getFullYear(), this.props.date.getMonth(), this.props.date.getDate(), this.props.min ? this.props.min.hours : 0, this.props.min ? this.props.min.minutes : 0, 0, 0).getTime() / 1000), this.props.dateFormat));
        // let endDate = new Date(this.props.getStringDateTs(Math.floor(new Date(this.props.date.getFullYear(), this.props.date.getMonth(), this.props.date.getDate(), this.props.max ? this.props.max.hours : 23, this.props.max ? this.props.max.minutes : 59, 59, 999).getTime() / 1000), this.props.dateFormat));
        let daySplitted = [];
        for (let i = 0; i < (endDate.getTime() - newDate.getTime()) / 1000 / 60 / 60; i++) {
            let newDate = new Date(this.props.date.getFullYear(), this.props.date.getMonth(), this.props.date.getDate(), this.props.min ? this.props.min.hours : 0, this.props.min ? this.props.min.minutes : 0, 0, 0);
            // let newDate = new Date(this.props.getStringDateTs(Math.floor(new Date(this.props.date.getFullYear(), this.props.date.getMonth(), this.props.date.getDate(), this.props.min ? this.props.min.hours : 0, this.props.min ? this.props.min.minutes : 0, 0, 0).getTime() / 1000), this.props.dateFormat));
            newDate.setMinutes(i * 60);
            daySplitted.push({ date: newDate, timestamp: Math.floor(newDate.getTime() / 1000) });
        }
        if (typeof window == 'undefined') {
            return null;
        }

        const VISIBLE_COLUMNS = typeof window != 'undefined' && window.innerWidth < 768 ? 2 : 5;

        const columnWidth = this.props.cols.length > VISIBLE_COLUMNS ? this.root && (this.root.offsetWidth / VISIBLE_COLUMNS) : this.root && (this.root.offsetWidth / this.props.cols.length);
        return (
            <div>
                {
                    this.state.clipboard && this.state.clipboard.length ?
                        <div className="drag-and-drop-calendar-clipboard">
                            <h4>{'Clipboard'.translate(this.props.lang)}</h4>
                            <div className='clipboard-elements-wrap'>
                                {
                                    this.state.clipboard.map((item, idx) => {
                                        if (!item.eventId)
                                            return (
                                                <div key={item?._id || idx}
                                                    className={`clipboard-element`}
                                                    style={getColorOfEvent(item.type, item.onlineVisit, item)}
                                                    draggable={true}
                                                    unselectable="on"
                                                    onDragStart={e => {

                                                        this.setState({
                                                            dragElementType: item
                                                        })

                                                        e.dataTransfer.setData("text/plain", "")

                                                    }}
                                                >
                                                    <h6>{this.props.getStringDateTs(item.startTime, 'HH:mm')/*moment.unix(item.startTime).format('HH:mm')*/} - {this.props.getStringDateTs(item.endTime, 'HH:mm')/*moment.unix(item.endTime).format('HH:mm')*/}</h6>
                                                    <h5>{item.type == 'free' ? item.title.translate(this.props.lang) : item.title}</h5>
                                                    <div
                                                        style={{ position: 'absolute', top: 5, right: 10, color: 'white', fontSize: 16, cursor: 'pointer' }}
                                                        onClick={() => this.props.removeFromClipboard(item)}
                                                    >&times;</div>
                                                </div>
                                            )
                                    })
                                }
                            </div>
                        </div>
                        :
                        null
                }

                <div className="drag-and-drop-calendar-wrap" ref={(node) => this.root = node}>

                    <div className="drag-and-drop-calendar-head" style={{ width: columnWidth * this.props.cols.length }}>
                        {
                            this.props.cols.map((item, idx) => {
                                return (
                                    <div key={idx} className="drag-and-drop-calendar-column" style={{ width: columnWidth }}>
                                        <div className="drag-and-drop-calendar-column-head">
                                            {item.name}
                                            {!item.clipboard ? <div className="delete-item" onClick={() => this.props.deleteItem(item)}>&times;</div> : null}
                                        </div>
                                        {
                                            this.props.holidayEvents && this.props.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(this.props.date).getDate() && new Date(el.date).getMonth() === new Date(this.props.date).getMonth() && new Date(el.date).getFullYear() === new Date(this.props.date).getFullYear()).length > 0 ?
                                                this.props.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(this.props.date).getDate() && new Date(el.date).getMonth() === new Date(this.props.date).getMonth() && new Date(el.date).getFullYear() === new Date(this.props.date).getFullYear()).map((el, index) => {
                                                    return <LightTooltipHoliday title={this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()} placement="top-start" >
                                                        <div key={index} className="rbc-event-label " style={{ display: 'flex', maxWidth: 200, backgroundColor: '#e7e7e7', borderTopRightRadius: '5px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px', color: '#000', }}>
                                                            <div style={{ backgroundColor: '#e61f00', height: 20, minWidth: 10 }}></div>
                                                            <div style={{ paddingLeft: 5, paddingRight: 5, maxWidth: 200, fontSize: '14px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()}</div>
                                                        </div>
                                                    </LightTooltipHoliday>
                                                })
                                                :
                                                null

                                        }
                                    </div>
                                )
                            })
                        }
                    </div>


                    <div className="drag-and-drop-calendar-scroll" style={{ width: columnWidth * this.props.cols.length }}>

                        <div className="drag-and-drop-calendar-layout">
                            {
                                this.props.cols.map((item, idx) => {
                                    return (
                                        <div key={idx} className="drag-and-drop-calendar-column" style={{ width: columnWidth }}>

                                            <div>
                                                {
                                                    daySplitted.map((block, bidx) => {
                                                        return (
                                                            <div
                                                                key={bidx}
                                                                className="drag-and-drop-calendar-column-block" style={{ height: SECOND_HEIGHT * 60 * 60 }}>
                                                                {!item.clipboard ?
                                                                    <div className="drag-and-drop-calendar-column-block-time">
                                                                        {moment.unix(block.timestamp).format('HH:mm')}
                                                                    </div>
                                                                    : null}
                                                                <div className="drag-and-drop-calendar-column-block-grid">
                                                                    {
                                                                        ([...Array(Math.floor(60 * 60 / STEP))]).map((item, idx) => {
                                                                            return <div key={idx} className="drag-and-drop-calendar-column-block-grid-line"></div>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className="drag-and-drop-calendar-rgl" style={{ height: 24 * 60 * 60 * SECOND_HEIGHT, width: columnWidth * this.props.cols.length }}>
                            <RGL
                                layout={layout}
                                width={columnWidth * this.props.cols.length}

                                // when allowOverlap is true this doesn't work so logic is in onDragStop and onResizeStop
                                // onLayoutChange={(layout) => {
                                //     console.log('layout', layout)
                                //     // if(!this.state.dragElementType){
                                //     //     this.onLayoutChange(layout)
                                //     // }
                                //     // this.onLayoutChange(layout)
                                // }}

                                //draggableHandle={".app-builder-drag-handle"}
                                onDrag={(layout, oldItem, newItem, placeholder, e, element) => {
                                    if (oldItem?.i?.indexOf('additional') > -1) {
                                        return oldItem;
                                    }
                                }}
                                margin={[0, 0]}
                                droppingItem={this.state.dragElementType && { i: 'test', w: 1, h: Math.ceil((((this.state.dragElementType.endTime - this.state.dragElementType.startTime) / (5 * 60)))) }}
                                onDrop={this.onDrop}
                                isDroppable={true}
                                cols={this.props.cols.length}
                                rowHeight={STEP_HEIGHT}
                                verticalCompact={false}
                                preventCollision={true}
                                maxRows={24 * 60 * 60 / STEP}
                                allowOverlap={true}
                                onDragStop={(layout, oldItem, newItem, placeholder, e, element) => {
                                    if (oldItem?.i?.indexOf('additional') > -1) {
                                        let index = layout.findIndex(el => el.i == oldItem.i);
                                        if (index > -1) {
                                            layout[index] = { ...oldItem }
                                        }
                                    }
                                    this.onLayoutChange(layout)
                                }}
                                onResizeStop={(layout, oldItem, newItem, placeholder, e, element) => {
                                    if (oldItem?.i?.indexOf('additional') > -1) {
                                        let index = layout.findIndex(el => el.i == oldItem.i);
                                        if (index > -1) {
                                            layout[index] = { ...oldItem }
                                        }
                                    }
                                    this.onLayoutChange(layout)
                                }}
                            >
                                {
                                    items.map((item, idx) => {
                                        const overlapData = item.overlapData ?? null;
                                        let style = {}
                                        if (overlapData?.position > -1 && overlapData?.total) {
                                            style.width = columnWidth / overlapData.total;
                                            style.left = columnWidth / overlapData.total * overlapData.position;
                                            if (overlapData?.position) {
                                                style.paddingLeft = 0;
                                            }
                                            this.setWidthOfElement(`drag-and-drop-calendar-event-${item._id}`, style.width)
                                        }
                                        return (
                                            <div key={item._id} className={`drag-and-drop-calendar-event drag-and-drop-calendar-event-${item._id}`} style={style ? style : null}>
                                                <div>
                                                    {this.props.components?.[item.type]?.(item)}
                                                </div>
                                                <div className="more-icon-wrap" onClick={() => this.setState({ contextMenu: item })}>
                                                    <div>
                                                        <Isvg src={moreIcon} />
                                                        {
                                                            this.state.contextMenu && this.state.contextMenu._id == item._id ?
                                                                <div className='drag-and-drop-context-menu-overlay-context-menu-wrap' ref={node => this.wrapperRef = node}>

                                                                    <div className={!item.eventId && !item.eventFromAnotherClinic && !item?.takeCare & !item?.additionalDoctor && !item.inClipboard && !item.reserved && item.startTime > Math.floor(new Date().getTime() / 1000) ? "drag-and-drop-context-menu-overlay-context-menu" : "drag-and-drop-context-menu-overlay-context-menu disabled-context-menu"}>
                                                                        <ul>
                                                                            <li><button onClick={(e) => {
                                                                                e.stopPropagation()
                                                                                if (!item.eventId && !item.eventFromAnotherClinic && !item?.takeCare && !item?.additionalDoctor && !item.inClipboard && item.startTime > Math.floor(new Date().getTime() / 1000)) {
                                                                                    this.props.moveToClipoboard(this.state.contextMenu, () => {
                                                                                        this.setState({ contextMenu: null })
                                                                                    })
                                                                                }
                                                                            }}

                                                                            >{'Move to clipoboard'.translate(this.props.lang)}</button></li>
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                                :

                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                {/* <div className="drag-and-drop-context-menu-overlay" onClick={() => this.setState({ contextMenu: null })}></div> */}

                                            </div>
                                        )
                                        // }

                                    })
                                }
                            </RGL>
                        </div>


                    </div>

                </div>
            </div >

        )
    }
}

export default DragAndDropList;